import BaseProxy from './BaseProxy';

class Auth extends BaseProxy {
    constructor(parameters = {}) {
        super('/api/v1', parameters);
    }

    async login(params = {}) {
        return this.submit('post', '/student/login', params);
    }

    async register(params = {}) {
        return this.submit('post', '/register', params);
    }

    async passwordEmail(params = {}) {
        return this.submit('post', '/password/email', params);
    }

    async resetPassword(params = {}) {
        return this.submit('post', '/reset/password', params);
    }

    async changeLanguage(params = {}) {
        return this.submit('post', '/change/language', params);
    }

    async getCurrent() {
        return this.submit('get', '/user/current');
    }

    async setImage(params = {}) {
        return this.submit('put', '/user/image', params);
    }

    async dashboardInfo() {
        return this.submit('get', `/user/dashboard`);
    }
}

export default Auth;



// WEBPACK FOOTER //
// ./src/api/Auth.js